import { RootState } from '../../../applicationStore';
import { SkillState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getSkillState = (state: RootState): SkillState => state.skill;

export const getSkillLoader = createSelector(
  getSkillState,
  (state): boolean => state.loading,
);

export const getSkillData = createSelector(
  getSkillState,
  (state): SkillState['data'] | null => state?.data || null,
);
